import type { ShopifyMoneyFacts } from "../../api/types";
import { webPaymentState } from "./orderMoneyUi";

/**
 * G-152 (WO-F part 1): what Shopify charged for a web order — goods,
 * shipping, tax, discount — and its payment state. Labels and numbers only.
 * An order stored before G-152 shows Shopify's total alone (the split is an
 * honest unknown). Shown in the office order window (with the Shopify order
 * number) and on the Shopify orders page (KI-150, whose card already names
 * the order).
 */
export function WebOrderMoney({
  shopify,
  label,
}: {
  shopify: ShopifyMoneyFacts;
  /** A leading label ("Shopify #N"); none where the order is already named. */
  label?: string;
}) {
  const state = webPaymentState(shopify.financialStatus);
  return (
    <div className="order-detail-web-money">
      {label ? <span className="muted">{label}</span> : null}
      {shopify.subtotalEur !== null ? (
        <>
          <span>Goods {shopify.subtotalEur} €</span>
          <span>Shipping {shopify.shippingEur} €</span>
          <span>
            Tax {shopify.totalTaxEur} € {shopify.taxesIncluded ? "incl." : "added"}
          </span>
          <span>Discount {shopify.totalDiscountsEur} €</span>
        </>
      ) : null}
      <span>Total {shopify.totalEur} €</span>
      <span className={state.className}>{state.label}</span>
      {shopify.cancelledAt ? <span className="badge danger">Cancelled in Shopify</span> : null}
      {shopify.paymentGatewayNames.length > 0 ? (
        <span className="muted">{shopify.paymentGatewayNames.join(", ")}</span>
      ) : null}
    </div>
  );
}
